import React, { useEffect, useRef, useState } from 'react';
import { BUTTON_TYPE } from '../../../constants/constant';
import IMAGES_PATH from '../../../Images';
import { Button } from '../../common/Button';
import IconContainer from '../../common/IconContainer';
import './style.css'
import { useIsMobile } from '../../../hooks/useIsMobile';
import { useNavigation } from '../../../hooks/useNavigate';
import { t } from '../../../translation/translation';

type TSectionModuleAndCartel = {
  children?: React.ReactNode;
  subtitle?: string;
  title?: string;
  underTitle?: string;
  buttonLabel?: string;
  cartelItems?: TBlueCartelItems[];
}

type TBlueCartelItems = {
  icon: string;
  title: JSX.Element;
  description: string;
}

const SectionBlueAndCartel = ({
  children,
  subtitle = "",
  title = "",
  underTitle = "",
  buttonLabel = "",
  cartelItems = []
}: TSectionModuleAndCartel): JSX.Element => {

  const {
    goToMission,
  } = useNavigation()

  const isMobile = useIsMobile()

  const sectionRef = useRef<HTMLDivElement>(null);
  const [sectionHeight, setSectionHeight] = useState<number | null>(null);

  useEffect(() => {
    const updateSectionHeight = () => {
      if (sectionRef.current) {
        const height = sectionRef.current.offsetHeight;
        setSectionHeight(height);
        sectionRef.current.parentElement?.style.setProperty('--section-height', `${height}px`);
      }
    };

    updateSectionHeight(); // initial call

    window.addEventListener('resize', updateSectionHeight);
    return () => {
      window.removeEventListener('resize', updateSectionHeight);
    };
  }, []);

  return (
    <div className='section'>
      <div
        className='section-module-cartel-container'
      >
        <div
          className='section-module-cartel-image'
          style={{
            backgroundImage: `url(${IMAGES_PATH.BACKGROUND_CIRCLE})`,
          }}
        >
          {subtitle ? <h4 className='text-white section-module-cartel-subtitle'>{subtitle}</h4> : null}
          <h2 className='text-white section-module-cartel-title'>{title}</h2>
          {underTitle ? <p className='text-white section-module-cartel-undertitle'>{t(underTitle)}</p> : null}
          {buttonLabel ?
            <Button
              label={buttonLabel}
              type={BUTTON_TYPE.SECONDARY}
              onClick={goToMission}
            />
          : null}
          {children}
        </div>
        {isMobile ?
          <div
            className='section-module-cartel-cartel-container-mobile'
          >
            {/* <div className='section-module-cartel-cartel-spacer'> */}
            {cartelItems.map(({ icon, title, description }, index) => (
              <div
                key={index}
                className='section-module-cartel-cartel'
              // style={sectionHeight ? { height: sectionHeight } : undefined}
              >
                <div className='section-module-cartel-header'>
                  <IconContainer image_path={icon} />
                  {title}
                </div>
                <p>{description}</p>
              </div>
            ))}
            {/* </div> */}
          </div>
          : null}
      </div>
      {!isMobile ?
        <div
          ref={sectionRef}
          className='section-module-cartel-cartel-container'
        >
          <div className='section-module-cartel-cartel-spacer'>
            {cartelItems.map(({ icon, title, description }, index) => (
              <div
                key={index}
                className='section-module-cartel-cartel'
                style={sectionHeight ? { height: sectionHeight } : undefined}
              >
                <div className='section-module-cartel-header'>
                  <IconContainer image_path={icon} />
                  {title}
                </div>
                <p>{description}</p>
              </div>
            ))}
          </div>
        </div>
        :
        null
      }
    </div>
  );
};

export default SectionBlueAndCartel;